import { useQuery } from '@tanstack/react-query'
import { agentsApi } from '@/lib/api'

export function useAgents() {
  return useQuery({
    queryKey: ['agents'],
    queryFn: () => agentsApi.list(),
    staleTime: 30_000,
  })
}
